import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { logout } from '../../auth/keycloak';
import { LoadingPage } from './LoadingPage';
import { usePageTitle } from '../../layout/usePageTitle';

/** Target of the header logout link when opened directly (e.g. in a new tab). */
export function LogoutPage() {
  const { t } = useTranslation();
  usePageTitle([t('header.logout')]);
  useEffect(() => {
    void logout();
  }, []);
  return <LoadingPage />;
}
